const LoadingSpinner = () => (
    <div className="flex items-center justify-center h-screen bg-white">
        <div className="w-20 h-20 border-8 border-gray-300 border-t-[8px] border-t-[#2F4F2F] rounded-full animate-spin"></div>
    </div>
);

export default LoadingSpinner;
